import {Component, Inject, OnInit} from '@angular/core';
import {Partner} from "../../../shared/interface/partner";
import {Ofwca} from "../../../shared/interface/ofwca";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {PartnerService} from "../../../shared/services/partner.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {validIban} from "../../../shared/validator/iban-validator";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {OfwcaService} from "../../../shared/services/ofwca.service";

export interface ChangeRegionalDialogData {
  ofwcaObject: Ofwca;
}
@Component({
  selector: 'app-ofwca-change-account-number-dialog',
  templateUrl: './ofwca-change-account-number-dialog.component.html',
  styleUrls: ['./ofwca-change-account-number-dialog.component.scss']
})
export class OfwcaChangeAccountNumberDialogComponent implements OnInit {

  changeAccountNumberForm: FormGroup;
  ofwcaObject: Ofwca;
  processingRequest = false;
  accountNumberControl: FormControl;
  enableSaveButton = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<OfwcaChangeAccountNumberDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRegionalDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
  ) {
    this.ofwcaObject = data.ofwcaObject;
    this.changeAccountNumberForm = fb.group({
      accountNumber: this.accountNumberControl = fb.control('', [Validators.required, validIban()]),
    });
  }

  ngOnInit(): void {
    this.changeAccountNumberForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changeAccountNumberForm.valid);

  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;

    this.ofwcaService.changeAccountNumber(this.changeAccountNumberForm.value, this.ofwcaObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano obiekt partnera', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji obiektu partnera wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
